import { render } from "./CheckoutArea.vue?vue&type=template&id=bb7c7180"
import script from "./CheckoutArea.vue?vue&type=script&lang=js"
export * from "./CheckoutArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__